import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock } from "lucide-react";
import { fmtTime } from "@/lib/tps";

/** value is "HH:mm" 24h, displayed in AM/PM */
export default function TimePicker({ value, onChange, testId }) {
  const slots = [];
  for (let h = 6; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    }
  }
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="h-8 border-[#E8E3DF] bg-white" data-testid={testId || "time-picker"}>
        <Clock className="h-3.5 w-3.5 mr-1 text-[#B86F77]" />
        <SelectValue placeholder="Pick time">
          {value ? fmtTime(value) : "Pick time"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {slots.map((s) => (
          <SelectItem key={s} value={s}>{fmtTime(s)}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
